import { render, staticRenderFns } from "./driverTotals.vue?vue&type=template&id=e28d5968&"
import script from "./driverTotals.vue?vue&type=script&lang=ts&"
export * from "./driverTotals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports